import BasicAccordionItem from "@components/BasicComponents/Accordion/BasicAccordionItem"
import {CategoryModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import CheckboxInput from "../../Checkbox/Checkbox"

import styles from "./CategoriesSelects.module.scss"

type Props = {
	element: CategoryModuleType
	selectedCategories: string[]
	onCheckboxChange: (title: string) => void
}

const CategoriesSelects: React.FC<Props> = ({
	element,
	onCheckboxChange,
	selectedCategories,
}: Props) => {
	return (
		<BasicAccordionItem title={element.title}>
			{element?.childrens?.map((element2: any, index2: number) => (
				<div key={index2} className={styles.checkbox}>
					<CheckboxInput
						checked={selectedCategories?.includes(element2.title)}
						label={`${element2.title} `}
						name={element2.slug}
						onChange={() => onCheckboxChange(element2.title)}
					/>
				</div>
			))}
		</BasicAccordionItem>
	)
}

export default CategoriesSelects
